import { Autocomplete, Backdrop, Grid, IconButton, TextField, Typography } from "@mui/material";
import axios from "axios";
import React, { Fragment, memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useStyle } from "../style";
import dayjs from "dayjs";
import _ from "lodash";
import CustomTable from "../customTable";
import moment from "moment";
import { Helmet } from "react-helmet-async";
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModalTable from "../../../../../components/utils/modalTable/modalTable";
import CashCloseTable from "../../../../../components/utils/modalTable/cashCloseTable";
import { date } from "yup";
import { Print } from "@mui/icons-material";
import { onPressButton, setThermalData } from "../../../../../components/hooks/printPdf/thermalData";
import { useNavigate } from "react-router-dom";

const OtExpenseClose = () => {
  const classes = useStyle()
  const dispatch = useDispatch();
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [data, setData] = useState([]);
  const [rowData, setRowData] = useState(null)
  const [supplier, setSupplier] = useState([]);
  const navigate = useNavigate()
  const[salesLines , setSalesLines] = useState([])
  const [open , setOpen] = useState(false)
  const [companyData , setCompanyData] = useState([])
  const [totalAmount , setTotalAmount] = useState(0) // overall amount in footer
    const [totalFlag , setTotalFlag] = useState(false) // set the total flag true
    const roleId = localStorage.getItem("role_id")
    const outletName = localStorage.getItem('outlet_name')
    const outletId = localStorage.getItem('outlet_id')
  const [dateLimit, setDateLimit] = useState({
    fromDate :  moment().startOf('month').format(),
    toDate :  moment().format()
  })
  const[cust, setCust] = useState(null)
  const fixedOutlet = { id: outletId, fullname: outletName };
  const onEdit = (e) => {
    console.log(e.row)
    setSalesLines(e.row.closing_expences_lines)
    setRowData(e.row)
    setOpen(true)
  }
  console.log(salesLines)
const columns = [
  {
    field : 'sno',
    headerName : 'S.no',
    minWidth : 70,
    headerAlign : 'center',
    align : 'center',
    sortable: false
  },
  {
    field: "date1",
    headerName: "Date",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "salesManCode",
    headerName: "Salesman Code",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field:"salesManName",
    headerName: "Salesman Name",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "otCode",
    headerName: "Outlet Code",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "party",
    headerName: "Outlet Name",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "opening_balance",
    headerName: " Opening Balance",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "expences_amount",
    headerName: "Expences Amount",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "closing_balance",
    headerName: "Closing Balance",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "tot",
    headerName: "Total",
    minWidth: 130,
    headerAlign: "center",
    align: "right",
    sortable: false,
    renderCell: (params) => (
      <strong>{params.value}</strong>
    ),
  },
  {
    field: "view",
    headerName: "View",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
    disableExport: true ,
    renderCell: (params) => {
      return (
        <div>
          <IconButton size="small" onClick={() => onEdit(params)}><VisibilityIcon /></IconButton>
            <IconButton size="small" onClick={()=>handleThermal(params.row)}><Print sx={{fontSize: 18}}/></IconButton>

        </div>
        
      );
    },
  },
]
// useEffect(() => {
//   axios.get(`/v1/outlet/info/${outletId}`)
//   .then((res) => {console.log(res.data);setCompanyData(res.data)})
//   .catch((err) => {console.log(err)})
//     },[])
  function handleThermal(e){
    console.log('Working!',e)
    console.log(e)
    const textData = {
      tot:e.tot,
      date:e.documentDate,
      employee:e.salesManName,
      opening_balance:e.opening_balance,
      expences_amount:e.expences_amount
    }
    const tableData = _.map(e.closing_expences_lines, ((val , idx)=>({ 
      sno:++idx,
     denomination:val.denomination,
     count:val.count,
     total:val.total
    })))
    console.log(tableData)
    console.log(textData)
   
    dispatch(setThermalData({
      tableData : tableData,
      TotalData : textData,
      companyInfo:cust
    }))      
    dispatch(onPressButton())
    const name = `ExpenseBill`
    navigate(`/expenseClose/${name}`)  
   
        }
        console.log(cust)
const rows = _.map(data,(val,idx)=>({
  id: val.id,
  sno: idx+1,
  date1 : moment(val.date).format("DD-MM-YYYY"),
  salesManCode : val.sales_man_code,
  salesManName:val.sales_man_name,
  otCode:val.code,
  party : val.fullname,
  opening_balance:parseFloat(val.opening_balance).toFixed(0),
  expences_amount:parseFloat(val.expences_amount).toFixed(0),
  tot: parseFloat(val.total_amount).toFixed(0),
  closing_expences_lines:val.closing_expences_lines,
  closing_balance:parseFloat(val.closing_balance).toFixed(0),
  documentDate:moment(val.date).format("DD-MM-YYYY"),
}))
const props = {
  columns : columns,
  rows : rows,
  page: page,
  setPage: setPage,
  rowsPerPage: rowsPerPage,
  setRowsPerPage: setRowsPerPage,
  pageCount: pageCount,
  pageOption: pageOption,
  totalAmount:totalAmount,
  totalFlag:totalFlag
}
useEffect(() => {
  // Calculate total balance amount
  setTotalFlag(true)
  let total = 0;

  data.forEach(val => {
      total += parseFloat(val.total_amount);
  });
  setTotalAmount(total.toFixed(0));
}, [data]);
const tableHeadData = [
  { id:1, label: "S No" },
  { id:2, label: "Date" },
  { id:3 , label:"denomination"},
  { id:4, label:"count"},
  { id:5 , label:"total"},
];
const tableBodyData = _.map(salesLines, (val,idx) => ({
  id:idx,
  sNo:idx+1,
  count:parseFloat(val.count).toFixed(0),
  denomination:val.denomination,
  date:moment(val.created_at).format("DD-MM-YYYY"),
  total:parseFloat(val.total).toFixed(0),
}))
  function handleChange(e, name) {
    setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
  }
  function getSupplierData() {
    axios
      .get("/v1/outlet/list/1")
      .then((res) => {
        setSupplier(res.data);
        _.filter(res.data,val=>val.id== outletId).map(val=>setCust(val))
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }
function handleSalesReturn(){
  const postData = {
    from_date:moment(dateLimit.fromDate).format('YYYY-MM-DD'),
    to_date: moment(dateLimit.toDate).format('YYYY-MM-DD'),
      customer: cust!==null ? cust.id : fixedOutlet.id
  }
  axios.post('/v1/reports/closing/expences', postData)
  .then(res=>{
    setData(res.data)
    setPageCount(res.data.length)
  })
  .catch(err=>{
    // dispatch(setSnackbar(true, "error", err.response.data.errors[0].message));
    setData([])
  })
}
  useEffect(() => {
    getSupplierData();
  }, []);
  
  useEffect(()=>{
    if( dateLimit.fromDate!==null && dateLimit.toDate!==null){
      handleSalesReturn()
      console.log('Vanthuden')
    }
  },[rowsPerPage, page, dateLimit, cust])
  console.log(roleId != 2 )
  return (
    <Fragment>
      <Helmet><title>Expense Close Reports</title></Helmet>
      <Typography variant="h6">Expense Close Reports</Typography>
      <Grid container spacing={2} className="p-2 pt-2">
        <Grid item md={3}>
          <Autocomplete 
            size="small"
            value={cust}
            options={supplier}
            onChange={(e,value)=>setCust(value)}
            getOptionLabel={option=>option.fullname}
            disabled={roleId != 1 && roleId != 2} 
            renderInput={(params) => <TextField {...params} label="Select Outlet"/>}
          />
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              // disabled={roleId != 1 && roleId != 2}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label:'From',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              // disabled={roleId != 1 && roleId != 2}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label:'To',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>
      <CustomTable props={props}/>
      <Backdrop open={open} sx={{zIndex:9999}}>
        <CashCloseTable tableHeadData={tableHeadData} tableBodyData={tableBodyData} setOpen={setOpen} data={rowData}/>
      </Backdrop>
    </Fragment>
  );
};

export default memo(OtExpenseClose);
